import { render, staticRenderFns } from "./im-invite-message.vue?vue&type=template&id=9645d472&scoped=true"
import script from "./im-invite-message.vue?vue&type=script&lang=js"
export * from "./im-invite-message.vue?vue&type=script&lang=js"
import style0 from "./im-invite-message.vue?vue&type=style&index=0&id=9645d472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9645d472",
  null
  
)

export default component.exports